import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Orderbook.scss";
import { Nav, Tab } from "react-bootstrap";
import OrderBuy from "./OrderBuySell/OrderBuySell.jsx";
import OrderBookThicker from "./OrderBookThicker/OrderBookThicker.jsx";
import { OrderBookHook } from "../../../hooks/marketDataHook";
import CardHeading from "../../../components/common/CardHeading/CardHeading.jsx";
const OrderBook = ({
  sectionRef
}) => {
  const rootRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const {
    buyOrderBook,
    sellOrderBook
  } = OrderBookHook();
  const setOrderBookRootRef = useCallback(node => {
    rootRef.current = node;
    if (typeof sectionRef === "function") {
      sectionRef(node);
    } else if (sectionRef) {
      sectionRef.current = node;
    }
  }, [sectionRef]);
  useEffect(() => {
    const syncFullscreen = () => {
      const el = rootRef.current;
      const active = document.fullscreenElement === el || document.webkitFullscreenElement === el;
      setIsFullscreen(Boolean(active));
    };
    document.addEventListener("fullscreenchange", syncFullscreen);
    document.addEventListener("webkitfullscreenchange", syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreen);
      document.removeEventListener("webkitfullscreenchange", syncFullscreen);
    };
  }, []);
  return <div className={`orderBook${isFullscreen ? " is-fullscreen" : ""}`} ref={setOrderBookRootRef}>
      <div className="orderBook__panel">
        <CardHeading title="Order Book" />
        <Tab.Container id="left-tabs-example" defaultActiveKey="gridlayoutone">
          <Tab.Content>
            <Tab.Pane eventKey="gridlayoutone">
              <OrderBuy orderBook={sellOrderBook} clrclass="red_text" side={1} head={true} orderclass="orderBooksell" />
              <div className="orderBook__midPrice">
                <OrderBookThicker />
              </div>
              <OrderBuy orderBook={buyOrderBook} side={0} clrclass="green_text" />
            </Tab.Pane>
            <Tab.Pane eventKey="gridlayouttwo">
              <OrderBuy orderBook={buyOrderBook} clrclass="green_text" side={0} head={true} />
              <div className="orderBook__midPrice">
                <OrderBookThicker />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="gridlayoutthree">
              <OrderBuy orderBook={sellOrderBook} clrclass="red_text" side={1} head={true} />
              <div className="orderBook__midPrice">
                <OrderBookThicker />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>;
};
export default OrderBook;